import { createClient } from "@supabase/supabase-js";

const projectURL = "https://auth.neum.ai";
const projectKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InlzaW1oZ2VlcmxrbGFoeXZ3eWxnIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODg2MDEyMTIsImV4cCI6MjAwNDE3NzIxMn0.DQOcTMDA2hdTdvVXYipEdCRGaEKnsSsv0XdxcpiMuk0";

export const supabase = createClient(projectURL, projectKey);